import React, {useEffect, useState} from 'react';
import Alert from '@mui/material/Alert';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import {getPermissionLevels} from './api';
import {getRoleLabel} from '../helpers/constants/roles';

export default function PermissionLevels() {
  const [levels, setLevels] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    getPermissionLevels().then(response => {
      if (!Array.isArray(response.data)) throw new Error('Missing permission levels');
      if (active) setLevels(response.data);
    }).catch(() => {
      if (active) setError(true);
    });
    return () => { active = false; };
  }, []);

  return (
    <div>
      <Typography variant="h5" component="h2" gutterBottom>Permission Levels</Typography>
      <Typography paragraph>
        Each permission level grants the scopes listed below, access can also depend on the user's <b>assigned sites</b> and other restrictions, e.g. a Site Manager has edit user permission but only for their site. Also a <b>guest</b> user is blocked from this app altogether.
      </Typography>
      {error && <Alert severity="error">Unable to load permission levels. Reopen this tab to try again.</Alert>}
      {!levels && !error && <Typography role="status">Loading permission levels…</Typography>}
      {levels?.map(({role, scopes}) => {
        const grouped = [...scopes].sort().reduce((groups, scope) => {
          const resource = scope.split(':')[0];
          if (!groups[resource]) groups[resource] = [];
          groups[resource].push(scope);
          return groups;
        }, {});
        return (
          <Accordion key={role}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{getRoleLabel(role)} ({scopes.length} scopes)</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table size="small" aria-label={`${getRoleLabel(role)} permission scopes`}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Resource</TableCell>
                      <TableCell>Available scopes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(grouped).map(([resource, resourceScopes]) => (
                      <TableRow key={resource}>
                        <TableCell component="th" scope="row">{resource}</TableCell>
                        <TableCell>{resourceScopes.join(', ')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {scopes.length === 0 && <Typography>No scopes assigned.</Typography>}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
